import { render, staticRenderFns } from "./ContractorContactPersonAdd.vue?vue&type=template&id=142be89c&"
import script from "./ContractorContactPersonAdd.vue?vue&type=script&lang=js&"
export * from "./ContractorContactPersonAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports